import { render, staticRenderFns } from "./PresellList.vue?vue&type=template&id=0257d23c&scoped=true&"
import script from "./PresellList.vue?vue&type=script&lang=js&"
export * from "./PresellList.vue?vue&type=script&lang=js&"
import style0 from "./PresellList.vue?vue&type=style&index=0&id=0257d23c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0257d23c",
  null
  
)

export default component.exports